'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fas';
var iconName = 'person-waving';
var width = 384;
var height = 512;
var aliases = [];
var unicode = 'e78d';
var svgPathData = 'M320-32c17.7 0 32 14.3 32 32l0 50c0 51.3-32.5 96.4-80 113.1L272 512c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-159.6c0-.1 0-.2 0-.4 0-8.8-7.2-16-16-16s-16 7.2-16 16l0 0 0 160c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-283.6c-.3 .5-.6 1-1 1.5L59.1 313c-9.4 15-29.1 19.5-44.1 10.2S-4.5 294 4.9 279l51.9-83c22.5-36 58.4-61.6 99.7-71.1l88.1-20.3C270 98.7 288 76.1 288 50l0-50c0-17.7 14.3-32 32-32zM136 24a56 56 0 1 1 112 0 56 56 0 1 1 -112 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faPersonWaving = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;